var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.0002,
    height: 24.0002,
    rx: 12.0001,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5807_81778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1123 6H6.88389C6.64895 6 6.42363 6.09333 6.2575 6.25946C6.09138 6.42558 5.99805 6.6509 5.99805 6.88584V17.1142C5.99805 17.3492 6.09138 17.5745 6.2575 17.7406C6.42363 17.9067 6.64895 18.0001 6.88389 18.0001H17.1123C17.3472 18.0001 17.5725 17.9067 17.7387 17.7406C17.9048 17.5745 17.9981 17.3492 17.9981 17.1142V6.88584C17.9981 6.6509 17.9048 6.42558 17.7387 6.25946C17.5725 6.09333 17.3472 6 17.1123 6ZM9.57474 16.2226H7.77056V10.4917H9.57474V16.2226ZM8.6714 9.69752C8.46674 9.69637 8.26702 9.63462 8.09743 9.52007C7.92784 9.40551 7.79598 9.24329 7.7185 9.05386C7.64101 8.86444 7.62138 8.65631 7.66207 8.45574C7.70277 8.25517 7.80196 8.07115 7.94714 7.9269C8.09231 7.78265 8.27697 7.68464 8.4778 7.64524C8.67862 7.60584 8.88662 7.62681 9.07554 7.7055C9.26446 7.7842 9.42584 7.9171 9.5393 8.08742C9.65277 8.25774 9.71323 8.45786 9.71307 8.66252C9.715 8.79953 9.68933 8.93554 9.63758 9.06242C9.58583 9.18931 9.50906 9.30447 9.41185 9.40106C9.31465 9.49764 9.19899 9.57366 9.07178 9.6246C8.94457 9.67553 8.8084 9.70033 8.6714 9.69752ZM16.2248 16.2276H14.4214V13.0967C14.4214 12.1734 14.0289 11.8884 13.5223 11.8884C12.9873 11.8884 12.4623 12.2917 12.4623 13.12V16.2276H10.6581V10.4959H12.3931V11.29H12.4164C12.5906 10.9375 13.2006 10.335 14.1314 10.335C15.1381 10.335 16.2256 10.9325 16.2256 12.6825L16.2248 16.2276Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5807_81778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.0001,
    height: 12.0001,
    fill: "white",
    transform: "translate(5.99805 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmLinkedIn);
export default __webpack_public_path__ + "static/media/SM_LinkedIn.1f3d9d899bf501c1915596da9360273c.svg";
export { ForwardRef as ReactComponent };